"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userWorkspacePermissionsDataLoaderFactory = void 0;
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var UserWorkspacePermissionsDataLoader = /** @class */ (function () {
    function UserWorkspacePermissionsDataLoader(workspace) {
        this.workspace = workspace;
    }
    UserWorkspacePermissionsDataLoader.prototype.getUserWorkspacePermissions = function (backend) {
        var _this = this;
        if (!this.cachedUserWorkspacePermissions) {
            this.cachedUserWorkspacePermissions = backend
                .workspace(this.workspace)
                .permissions()
                .getPermissionsForCurrentUser()
                .catch(function (error) {
                _this.cachedUserWorkspacePermissions = undefined;
                throw error;
            });
        }
        return this.cachedUserWorkspacePermissions;
    };
    return UserWorkspacePermissionsDataLoader;
}());
/**
 * @internal
 */
exports.userWorkspacePermissionsDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new UserWorkspacePermissionsDataLoader(workspace); });
//# sourceMappingURL=UserWorkspacePermissionsDataLoader.js.map